



























import {Component, Prop, Ref, Vue} from 'vue-property-decorator';
import JdhSneakPeek from "@/design-system/shared/JdhSneakPeek.vue"

/**
 * @status stable
 * @published 4.0.0
 * @changelog 4.0.0 Published.
 * @changelog 5.4.0 Switched to native tooltip, allow slot syntax.
 * @changelog 6.5.4 Place the question icon within the hitbox.
 */
@Component({
    components: {JdhSneakPeek}
})
export default class JdsTerminology extends Vue {
    @Prop() tooltip!: string
    @Ref() anchorEl!: HTMLElement

    showTooltip = false
}
